import { render, staticRenderFns } from "./OP_FindingSummaryCPTPrintable.vue?vue&type=template&id=20ca36f6&scoped=true&"
import script from "./OP_FindingSummaryCPTPrintable.vue?vue&type=script&lang=js&"
export * from "./OP_FindingSummaryCPTPrintable.vue?vue&type=script&lang=js&"
import style0 from "./OP_FindingSummaryCPTPrintable.vue?vue&type=style&index=0&id=20ca36f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ca36f6",
  null
  
)

export default component.exports